// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import store from './store'
import radio from './plugins/bus'
import { VueMaskDirective } from 'v-mask'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import './plugins/vuetify'
import './plugins/console'
import './plugins/money'
import './plugins/timezone'
import './plugins/formatRequestedDelivery'
import './plugins/orderStatusColor'
import './plugins/rtlTextAlign'
import './plugins/telephone'
import './plugins/currency-symbol'
import './plugins/services'
import './plugins/country'
import FlagIcon from 'vue-flag-icon'
import defaultLang from '../lang/en-US'

import helpers from '@/util/helpers'

// Auto register models from all modules
import container from './services/api/lib/container'

const requireModule = require.context('./modules', true, /register\.js$/)

const messages = {
  en: defaultLang
}

requireModule.keys().forEach((componentFilePath) => {
  const module = requireModule(componentFilePath).default
  const models = module.models()
  if (models) {
    Object.keys(models).forEach(function (key) {
      container.register(key, models[key])
    })
  }
})

// import Raven from "raven-js";
// import RavenVue from "raven-js/plugins/vue";

// Raven.config("http://841892f591714ec5824b82708e8facc7@94.130.230.12:9000/4")
//   .addPlugin(RavenVue, Vue)
//   .install();

Vue.config.productionTip = false

Vue.prototype.$radio = radio

// Global filters
Vue.filter('truncate', require('lodash.truncate'))

Vue.use({
  install () {
    Vue.helepers = Vue.prototype.$helpers = helpers
  }
})

Vue.use(require('vue-moment'))
Vue.use(require('v-hotkey'))
Vue.use(require('vue-quill-editor'))
Vue.use(FlagIcon)
Vue.use(VueI18n)

// Or as a directive-only
Vue.directive('mask', VueMaskDirective)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})
